import '../../../styles/Blog.css';
import {IMAGE_URL} from "../../../path";

type blogTwoImages = {
    image_1_url: string;
    image_2_url: string;
}

function BlogTwoImages(props: blogTwoImages) {
    return (
        <div className="blog-two-image-container">
            <div className="inner">
                <img src={`${IMAGE_URL}${props.image_1_url}`} alt="blog-image-1" />
            </div>
            <div className="inner">
                <img src={`${IMAGE_URL}${props.image_2_url}`} alt="blog-image-2" />
            </div>
        </div>
    )
}

export default BlogTwoImages;
